import { FC } from 'react'

export const NotFoundView: FC = () => {
  return (
    <div style={{ flex: '1 0 auto', textAlign: 'center' }}>
      <h1>404</h1>
      <h5>We were looking everywhere</h5>
    </div>
  )
}
